export default __webpack_public_path__ + "static/media/hi.343a8dd9.gif";